export default function updateOrganizationReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_ORGANIZATION_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_ORGANIZATION_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_ORGANIZATION_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}